// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3j-1";
export var rateTableServiceLevelDropdown = "_3j-3";
export var rateTableTypeDropdown = "_3j-0";
export var rateTableValueModeDropdown = "_3j-2";